import React from "react";
import * as dc from "dc";

import "leaflet/dist/leaflet.css";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.webpack.css"; // Re-uses images from ~leaflet package
import * as L from "leaflet";
import "leaflet-defaulticon-compatibility";
import * as dc_leaflet from "dc.leaflet";

import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

import { ChartTemplate } from "./chartTemplate";
const mapChartChartFunc = (divRef, ndx) => {
  // delete L.Icon.Default.prototype._getIconUrl;
  // console.log(L);
    // define the cordinates lat long
  const dimension = ndx.dimension((d) => {
      return [d.latitude, d.longitude];
  });
  const group = dimension.group().reduceCount();
  const all = ndx.groupAll();

  const markersChart = dc_leaflet.markerChart(divRef);
  markersChart
    .dimension(dimension)
    .group(group)
    // .center([0, 0])
    .center([0.95, 38.9419553])
    .showMarkerTitle(false)
    .fitOnRender(true)
    .fitOnRedraw(true)
    .filterByArea(true)
    .zoom(4)
    .height(506)
    .width(312)
    .renderPopup(false)
    .cluster(true);

  return markersChart;
};

export const MapChart = (props) => (
  <ChartTemplate chartFunction={mapChartChartFunc} title="Map View" id="mapview" />
);
